import vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import _module from './modules'
import persistencePlugin from './plugins/cache';

vue.use(Vuex)

const state = {
  initialized: false,
  acounts: {
    moddata: [],
    recordid: '',
    record_mod: false,
  },
  gameid: null // 所选游戏类别id
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: _module,
  strict: false,
  plugins: [persistencePlugin()]
})